<template>
  <router-view />
</template>

<script>
import storeMixin from '@/shared/mixins/storeGenerator';

export default {
  name: 'WrapperReferral',
  mixins: [storeMixin],
};
</script>
